// React
import React from 'react';
// Material-UI
import { Typography } from "@material-ui/core";
// Otras libs

// Componentes

// Vistas

// Servicios

// Funciones

// Hooks


/**
 * 
 * @typedef {Object} Props
 * @property {string} titulo Título de tarjeta
 * @property {'center' | 'left' | 'right'} tituloAlign Align de titulo
 * @property {string | undefined} detalle Contenido en texto de tarjeta
 * @property {React.ReactNode} componente Componente
 * @property {string | undefined} height Alto de tarjeta
 */

/**
 * Tarjeta
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const Tarjeta = ({ 
    titulo = '',
    tituloAlign = 'center',
    detalle = '', 
    componente,
    height,
}) => {
    // Idioma
    
    // Token
    
    // Estados

    // Paginador

    // Listas
    
    // Funciones
    
    // Otros

    // Vista
    return (
        <div>
            <table style= {{ borderCollapse: 'collapse', borderSpacing: 0, margin: '2px', width: '100%', height: height }}>
                <tbody>
                    <tr style={{ backgroundColor: '#f7f7f7' }}>
                        <td style={{ border: '1px solid #0000001f', color: '#0000008a', textAlign: tituloAlign, padding:'2px 4px 2px 4px' }}><b>{titulo}</b></td>
                    </tr>
                    <tr>
                        <td style={{ border: '1px solid #0000001f', textAlign: 'center', padding: '5px' }}>
                            {componente
                                ? componente
                                : <Typography variant="body2" style={{ whiteSpace: "pre-wrap" }}>{detalle}</Typography>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
